export default "__VITE_ASSET__BvBpRPAX__"